import { BasePageComponent } from '@/components/base/BasePageComponent';
import { PropertyHelper } from '@/helpers/property.helper';
import { UserHelper } from '@/helpers/user.helper';
import { AppConfigService } from '@/services/app-config.service';
import { MenuToNative, MenuToNativeId } from '@/services/bridge/bridge.service';
import { NavService } from '@/services/nav.service';
import { UserRightsService } from '@/services/user-rights.service';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { RealProperty, SharingDataCategory } from '@eemo/api-client';
import { Subscription } from 'rxjs';
import { TranslateModule } from '@ngx-translate/core';
import { TrackingTimelineComponent } from '../tracking-timeline/tracking-timeline.component';

import { RoundedLinkComponent } from '../../../components/rounded-link/rounded-link.component';
import { NgFor, NgIf } from '@angular/common';
import { TooltipDirective } from '@/directives/tooltip/tooltip.directive';

@Component({
    selector: 'app-tracking',
    templateUrl: './tracking.component.html',
    styleUrls: ['./tracking.component.scss'],
    standalone: true,
    imports: [NgIf, NgFor, RoundedLinkComponent, TrackingTimelineComponent, TranslateModule, TooltipDirective]
})
export class TrackingComponent extends BasePageComponent implements OnInit, OnDestroy {
  prop: RealProperty;
  list: MenuToNative[];

  canViewTimeline = false;

  constructor(
    public propHelper: PropertyHelper,
    public userHelper: UserHelper,
    public userRightService: UserRightsService,
    private appConfigService: AppConfigService,
    protected route: ActivatedRoute,
    public propertyHelper: PropertyHelper,
    protected navService: NavService
  ) {
    super(route, navService);
  }

  subs: Subscription[] = [];

  ngOnInit() {
    this.subs.push(
      this.appConfigService.selectedPropObs.subscribe((p) => {
        if (p) {
          this.prop = p;
          this.canViewTimeline = this.userHelper.canViewCategory(this.prop, SharingDataCategory.TIMELINE);
          this.loadData();
        }
      })
    );
    this.list = this.navService.getNavEnvById(MenuToNativeId.TRACKING)?.childs?.filter((m) => !m.removed) || [];
  }

  ngOnDestroy(): void {
    this.subs.forEach((s) => s.unsubscribe());
  }

  loadData() {}
}
